export const height = [
  {
    name: "1",
    value: "1",
  },
  {
    name: "2",
    value: "2",
  },
  {
    name: "3",
    value: "3",
  },
  {
    name: "4",
    value: "4",
  },
  {
    name: "5",
    value: "5",
  },
  {
    name: "6",
    value: "6",
  },
  {
    name: "7",
    value: "7",
  },
  {
    name: "8",
    value: "8",
  },
  {
    name: "9",
    value: "9",
  },
  {
    name: "10",
    value: "10",
  },
];

export const inches = [
  {
    name: "0",
    value: "0",
  },
  {
    name: "1",
    value: "1",
  },
  {
    name: "2",
    value: "2",
  },
  {
    name: "3",
    value: "3",
  },
  {
    name: "4",
    value: "4",
  },
  {
    name: "5",
    value: "5",
  },
  {
    name: "6",
    value: "6",
  },
  {
    name: "7",
    value: "7",
  },
  {
    name: "8",
    value: "8",
  },
  {
    name: "9",
    value: "9",
  },
  {
    name: "10",
    value: "10",
  },
  {
    name: "11",
    value: "11",
  },
];

export const hairColor = [
  {
    name: "Black",
    value: "black",
  },
  {
    name: "Blonde",
    value: "blonde",
  },
  {
    name: "Brown",
    value: "brown",
  },
  {
    name: "Red",
    value: "red",
  },
  {
    name: "Gray",
    value: "gray",
  },
  {
    name: "Bald",
    value: "bald",
  },
  {
    name: "Other",
    value: "other",
  },
];

export const eyeColor = [
  {
    name: "Amber",
    value: "amber",
  },
  {
    name: "Black",
    value: "black",
  },
  {
    name: "Blue",
    value: "blue",
  },
  {
    name: "Brown",
    value: "brown",
  },
  {
    name: "Gray",
    value: "gray",
  },
  {
    name: "Green",
    value: "green",
  },
  {
    name: "Hazel",
    value: "hazel",
  },
];
